import React from 'react';
import './Analytics_card.css';
import Arrow from '../../Assets/arrow.svg';
import Arrow2 from '../../Assets/arrow top.svg';

const Analytic_cards = ({ text1, text2, text3 }) => {
  return (
    <div className='analytic_card'>
      <div className='analytic_card_div1'>
        <div className='analytic_card_div2'>
          <h3 className='analytic_card_text1'>{text1}</h3>
          <h3 className='analytic_card_text1'>{text2}</h3>
        </div>
        <img className='analytic_card_icon1' src={Arrow} alt="" />
      </div>
      <div className='analytic_card_div3'>
        <img className='analytic_card_icon2' src={Arrow2} alt="" />
        <h5 className='analytic_card_text2'>{text3}</h5>
      </div>
    </div>
  );
};

export default Analytic_cards;